module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 const mediaAvailable = ( Object.keys( image ).length > 0 || ( Object.keys( video ).length > 0 ) ); 
__p+='\n\n';
 if ( mediaAvailable ) { 
__p+='\n<section class="mdl mdl_popup_content_moment_view mdl mdl_content moment_detail ">\n    ';
 } else { 
__p+='\n<section class="mdl mdl_popup_content_moment_view mdl mdl_content moment_detail no-image">\n    ';
 } 
__p+='\n    <div class="mdl_moment_view__subheading">Filiale '+
((__t=( subsidiary ))==null?'':__t)+
'</div>\n    <div class="mdl_moment_view__title">'+
((__t=( title ))==null?'':__t)+
'</div>\n    <div class="mdl_moment_view__content">\n        <div class="mdl_moment_view__text">\n            <div class="mdl_moment_view__text-inner en_wysiwyg">\n                '+
((__t=( story ))==null?'':__t)+
'\n            </div>\n            <div class="mdl_moment_view__text-author">— '+
((__t=( author ))==null?'':__t)+
'</div>\n        </div>\n\n        ';
 if ( mediaAvailable ) { 
__p+='\n        <div class="mdl_moment_view__image" style="text-align: center;">\n            ';
 if ( Object.keys( video ).length > 0 ) { 
__p+='\n             <video style="max-width: 100%; width:auto; max-height: 50vh" width="'+
((__t=( video.width ))==null?'':__t)+
'" height="'+
((__t=( video.height ))==null?'':__t)+
'" controls>\n                <source src="'+
((__t=( video.src ))==null?'':__t)+
'" type="video/mp4" >\n            </video>\n            ';
 } 
__p+='\n\n            ';
 if ( Object.keys( image ).length > 0 ) { 
__p+='\n            <img src="'+
((__t=( image.src ))==null?'':__t)+
'" style="max-width: 100%; width:auto; max-height: 50vh" width="'+
((__t=( image.width ))==null?'':__t)+
'" height="'+
((__t=( image.height ))==null?'':__t)+
'" alt="" loading="lazy" />\n            ';
 } 
__p+='\n        </div>\n        ';
 } else if ( ! isForm ) { 
__p+='\n                <div class="mdl_moment_view__figure"></div>\n        ';
 } 
__p+='\n    </div>\n    ';
 if ( isForm ) { 
__p+='\n    <div class="mdl_moment_add__controls">\n        <div class="mdl_moment_add__controls-preview-container">\n            <button type="button" class="mdl_moment_add__controls-preview-button en_button en_button--style_minimal en_button--shrink edit_moment" data-en-action="end_preview">Weiter bearbeiten</button>\n        </div>\n        <div class="mdl_moment_add__controls-submit-container">\n            <button type="submit" form="add_moment" class="mdl_moment_add__controls-submit-button en_button en_button--style_minimal en_button--color_primary en_button--shrink" >Moment teilen</button>\n        </div>\n    </div>\n    ';
 } 
__p+='\n</section>';
}
return __p;
};
